module.exports = __webpack_public_path__ + "static/media/cmf-logo.cbe990d1.png";